import React , { ReactNode } from "react";
import withPageContext from "../context/pageContext";
import { Global, css } from '@emotion/react'
import { GlobalStyles } from 'twin.macro'
import { withCookies } from 'react-cookie';
import { LocaleProvider } from "gatsby-theme-i18n";
import PageTemplate from "./pageTemplate";
import { CookiesProvider } from 'react-cookie';


import {
  GlobalStyles as ComponentLibraryStyle,
  ThemeProvider
} from 'ffxiv-html-components/style-library';



import { usePageContext } from "../context/pageContext/hook";
import { useLocaleStr } from "../utils/useLocaleStr";



type Props = {
  children?: ReactNode;
};

const MainTemplate: React.FC<Props> = (props) => {

  const { children } = props;
  const { pageContext, location } = usePageContext();
  const { localeData } = useLocaleStr();

  return (
    <>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <ThemeProvider defaultTheme={`light`}>
          <LocaleProvider pageContext={{...pageContext, locale : 'ja', localeData : localeData}} location={location}>
            <GlobalStyles />
            <ComponentLibraryStyle />
            <PageTemplate pageContext={pageContext}>
              {children}
            </PageTemplate>          
          </LocaleProvider>
        </ThemeProvider>
      </CookiesProvider>
    </>
  );

}

export default withCookies(withPageContext(MainTemplate));
